/**
 * Ensures that the current URL complies to RFC 3986.
 * (As sometimes this might not be the case in FF.)
 *
 * History and location objects could be provided as
 * the arguments. This is useful to have them mocked
 * in tests.
 *
 * @param {History} [history]   The history object
 * @param {Location} [location] The location object
 */
export const normalizeCurrentUrl = (history = window.history, location = window.location) => {
  const originalUrl = location.toString();
  const normalizedUrl = encodeURI(decodeURI(originalUrl));

  if (originalUrl !== normalizedUrl) {
    history.replaceState(null, null, normalizedUrl);
  }
};

/**
 * Decodes a potentially double-encoded URL or path.
 * This handles cases where URLs are encoded multiple times through redirect chains
 * (e.g., dispatch → SSO → login page).
 *
 * @param {string | null | undefined} href - The href to decode
 * @returns {string | null} The decoded href, or null if input was falsy
 */
export const decodeHrefParam = href => {
  if (!href) return null;

  let decoded = href;
  if (decoded.includes('%')) {
    try {
      const result = decodeURIComponent(decoded);
      if (result.startsWith('http') || result.startsWith('/')) {
        decoded = result;
      }
    } catch {
      // If decoding fails, use original value
    }
  }
  return decoded;
};

/**
 * Checks if a path is a relative path (starts with '/' but not '//').
 * Protocol-relative URLs ('//example.com') are NOT considered relative paths.
 *
 * @param {string} path - The path to check
 * @returns {boolean} True if the path is a relative path
 */
export const isRelativePath = path => {
  return path?.startsWith('/') && !path?.startsWith('//');
};
